"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenueSortsEnum = exports.VenueDurationBookableEnum = exports.VenueTypeEnum = void 0;
var VenueTypeEnum;
(function (VenueTypeEnum) {
    VenueTypeEnum["VILLA"] = "villa";
    VenueTypeEnum["CASTLE"] = "castle";
    VenueTypeEnum["HOTEL"] = "hotel";
    VenueTypeEnum["RESTAURANT"] = "restaurant";
    VenueTypeEnum["ENTIRE_TOWN"] = "entire_town";
    VenueTypeEnum["BARN"] = "barn";
    VenueTypeEnum["YURT"] = "yurt";
})(VenueTypeEnum = exports.VenueTypeEnum || (exports.VenueTypeEnum = {}));
var VenueDurationBookableEnum;
(function (VenueDurationBookableEnum) {
    VenueDurationBookableEnum["DAY"] = "day";
    VenueDurationBookableEnum["EXTENDED"] = "extended";
})(VenueDurationBookableEnum = exports.VenueDurationBookableEnum || (exports.VenueDurationBookableEnum = {}));
var VenueSortsEnum;
(function (VenueSortsEnum) {
    VenueSortsEnum["RECOMMENDED"] = "recommended";
    VenueSortsEnum["NEWEST"] = "newest";
    VenueSortsEnum["OLDEST"] = "oldest";
    VenueSortsEnum["PRICE_LOW"] = "priceLow";
    VenueSortsEnum["PRICE_HIGH"] = "priceHigh";
})(VenueSortsEnum = exports.VenueSortsEnum || (exports.VenueSortsEnum = {}));
//# sourceMappingURL=venues.js.map